import { useState, useCallback, useEffect } from "react";
import {
  Typography,
  Radio,
  InputAdornment,
  Box,
  Grid,
  TextField,
} from "@mui/material";
import BackIcon from "../IconComp/backIcon";
import AppButton from "../common/AppButton";
import AppModal from "../common/AppModal";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getInstruction } from "../../features/instructions/instructionSlice";
import { AddSales } from "../../features/sales/salesSlice";
import { EditSales } from "../../features/sales/salesSlice";
import { NewSaleEntry } from "./newSaleEntry";
import { useNavigate } from "react-router-dom";
import { PaymentModal } from "./payment-modal";
import { useSelector } from "react-redux";
import { PaginationDTO } from "../../dtos/manufacturer";
import { getCustomerHistory } from "../../features/customerHistory/customerHistorySlice";
import { theme } from "../../theme";

interface IProps {
  productionSelectedDate: any;
  editInvoiceId: any;
  handleCloseEditFunction: any;
  getSalesHistory?: any;
  setOpenSnackbar?: any;
}

const NewSaleCheckout = ({
  salesData,
  productionSelectedDate,
  editInvoiceId,
  handleCloseEditFunction,
  getSalesHistory,
  setOpenSnackbar,
}: any) => {
  const AmountToPaid = salesData[0]?.amount_to_be_paid;

  const totalAmountPaid = salesData?.reduce(
    (total: number, item: any) => total + item?.amount_to_be_paid,
    0
  );
  const dispatch = useAppDispatch();
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const [amountPaid, setAmountPaid] = useState<string>("");
  const [discountPercentage, setDiscountPercentage] = useState<any>("");
  const [paidAmount, setPaidAmount] = useState<any>();
  const [isChecked, setIsChecked] = useState(false);
  const [openInstructionModel, setOpenInstructionModel] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [paidAmountError, setPaidAmountError] = useState("");
  const [invoiceId, setInvoiceId] = useState<string>("");
  const navigate = useNavigate();
  const [showNewSaleEntry, setShowNewSaleEntry] = useState(false);
  const [savedModel, setSavedModel] = useState(true);
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [selectedEnumValue, setSelectedEnumValue] = useState(3);
  const [selectedPayment, setSelectedPayment] = useState("Cash");
  const { staff_id } = useSelector((state: any) => state?.staff);
  const staff_data = localStorage.getItem("staff_data");
  const StaffData = staff_data ? JSON.parse(staff_data) : null;
  const Id = staff_id || StaffData?.id;
  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3000);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const [customerData, setCustomerData] = useState<any>([]);
  const [customerDetial, setCustomerDetail] = useState<any>(false);

  const handleCutPhone = (value: any) => {
    const phone = value.replace(/\D/g, "").slice(0, 11);
    setCustomerPhone(phone);
    if (phone?.length === 11) {
      const matched = customerData?.find(
        (item: any) => item?.phone_number === phone
      );

      if (matched) {
        setCustomerName(matched.name || "");
        setCustomerId(matched?.id);
      }
    }
  };

  const handleCustName = (value: any) => {
    setCustomerName(value);
    // const matched = customerData?.find((item: any) => item?.name === value);

    // if (matched) {
    //   setCustomerPhone(matched.phone_number || "");
    // }
  };

  const getCustomerHistoryData = useCallback(async () => {
    const dto: PaginationDTO = {
      page: page + 1,
      limit: rowsPerPage,
      search: debouncedSearchQuery,
    };

    try {
      const res = await dispatch(
        getCustomerHistory({ pharmacy_id: pharmacyId, dto })
      );
      if (res?.payload) {
        setCustomerData(res?.payload?.customers);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
      setError("Error fetching customer data");
    } finally {
      setError("");
    }
  }, [dispatch, page, rowsPerPage, debouncedSearchQuery, pharmacyId]);

  useEffect(() => {
    getCustomerHistoryData();
  }, [
    getCustomerHistoryData,
    page,
    rowsPerPage,
    debouncedSearchQuery,
    pharmacyId,
  ]);

  useEffect(() => {
    if (invoiceId) {
      setInvoiceId(invoiceId);
    }
  }, [invoiceId]); // Watching for changes in invoiceId

  const handleOpenModal = () => setOpenModal(true);

  const handleInstructionModel = () => setOpenInstructionModel(true);
  const handleOpenPaymentModal = () => {
    setOpenPaymentModal(true);
    setOpenInstructionModel(false);
  };
  const handleCloseInstructions = () => setIsChecked(false);
  const handleCloseModal = () => setOpenModal(false);
  const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    {}
  );

  const handleCheckboxChange = (id: string) => {
    setCheckedItems(() => ({
      [id]: true, // Only the selected checkbox remains true, all others are false
    }));
  };

  const handleSaveModel = () => {
    setSavedModel(false);
  };
  const GetPolicy = useCallback(() => {
    dispatch(getInstruction(pharmacyID));
  }, [dispatch, pharmacyID]);

  useEffect(() => {
    if (pharmacyID) GetPolicy();
  }, [pharmacyID, GetPolicy]);

  const { instructionPayload }: any = useAppSelector(
    (state) => state.instruction
  );

  useEffect(() => {
    if (instructionPayload?.instruction) {
      const initialState = instructionPayload.instruction.reduce(
        (acc: { [key: string]: boolean }, item: any) => {
          acc[item.id] = false; // Default all to false
          return acc;
        },
        {}
      );
      setCheckedItems(initialState);
    }
  }, [instructionPayload]);

  const selectedInstructions = instructionPayload?.instruction?.filter(
    (item: any) => checkedItems[item.id]
  );

  const handleClose = () => {
    setOpenModal(false);
    setShowNewSaleEntry(true);
    localStorage.removeItem("salesData");
  };
  const handleClosePaymentModal = () => {
    setOpenPaymentModal(false);
  };

  const handleDiscountInputChange = (
    event: any,
    type: "percentage" | "amount"
  ) => {
    const value = event.target.value;

    // Allow only valid input
    if (!/^\d*\.?\d*$/.test(value)) return;

    if (value === "") {
      setDiscountPercentage("");
      setAmountPaid("");
      setErrorMessage("");
      return;
    }

    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) return;

    if (type === "percentage") {
      if (numericValue > 100) {
        setErrorMessage("Discount percentage cannot exceed 100%");
        return;
      }

      setDiscountPercentage(value);

      const rawAmount = (totalAmount * numericValue) / 100;
      const fixedAmount = Math.floor(rawAmount * 10) / 10; // Truncate instead of round
      setAmountPaid(fixedAmount.toString());
    }

    if (type === "amount") {
      if (numericValue > totalAmount) {
        setErrorMessage("Discount amount cannot exceed total amount");
        return;
      }

      setAmountPaid(value);

      const rawPercent = (numericValue / totalAmount) * 100;
      const fixedPercent = Math.floor(rawPercent * 100) / 100; // Truncate to 2 decimals
      setDiscountPercentage(fixedPercent.toString());
    }

    setErrorMessage("");
  };

  // Check if any entry has a sale_discount_percentage
  const hasDiscountPercentagePrevious = salesData?.some(
    (entry: any) => entry?.sale_discount_percentage
  );

  const totalAmount = salesData?.reduce(
    (total: any, entry: any) => total + parseFloat(entry?.amount_to_be_paid),
    0
  );

  const costPrice = salesData?.reduce(
    (total: any, entry: any) => total + parseFloat(entry?.cost_price),
    0
  );
  const quantity_to_be_sold = salesData?.reduce(
    (total: any, entry: any) => total + parseFloat(entry?.quantity_to_be_sold),
    0
  );

  const totalSaleDiscountAmount = salesData?.reduce(
    (total: number, entry: any) => {
      const discountAmount = parseFloat(entry?.sale_discount_amount);
      // Ensure the discountAmount is a valid number, otherwise default to 0
      return total + (!isNaN(discountAmount) ? discountAmount : 0);
    },
    0
  );

  const previousDiscountPercentage = totalAmount
    ? (totalSaleDiscountAmount / totalAmount) * 100
    : 0;

  const discountAmount =
    (totalAmount * parseFloat(discountPercentage)) / 100 || 0;
  const totalPayable = totalAmount - discountAmount || 0;
  const totalSingleMedDiscountPayable =
    totalAmount - totalSaleDiscountAmount || 0;
  const remainingAmount = parseFloat(paidAmount) - totalPayable || 0;
  const previousDiscountRemainingAmount =
    parseFloat(paidAmount) - totalSingleMedDiscountPayable || 0;

  useEffect(() => {
    if (
      totalAmount > 0 &&
      amountPaid !== "" &&
      !isNaN(parseFloat(amountPaid))
    ) {
      const Percentage = (parseFloat(amountPaid) / totalAmount) * 100;
      const roundedPercentage = parseFloat(Percentage.toFixed(2));
      setDiscountPercentage(roundedPercentage);
    } else {
      setDiscountPercentage("");
    }
  }, [amountPaid, totalAmount]);

  // selectedPayment !== "Cash"
  const handleSubmit = async () => {
    const pharmacyId = localStorage?.getItem("pharmacyId");
    const salesPayload = {
      pharmacy_id: pharmacyId,
      invoice_id: editInvoiceId,
      staff_id: parseInt(Id),
      add_by_admin: Id ? false : true,
      total_Amount: totalAmount,
      discount_percentage: hasDiscountPercentagePrevious
        ? previousDiscountPercentage
        : parseFloat(discountPercentage),
      discount_Amount: hasDiscountPercentagePrevious
        ? totalSaleDiscountAmount
        : discountAmount,
      after_discount_amount: hasDiscountPercentagePrevious
        ? totalSingleMedDiscountPayable
        : totalPayable,
      paid_amount:
        selectedPayment !== "Cash" && hasDiscountPercentagePrevious
          ? totalSingleMedDiscountPayable
          : selectedPayment !== "Cash"
          ? totalPayable
          : parseFloat(paidAmount),
      // return_amount: hasDiscountPercentagePrevious
      //   ? previousDiscountRemainingAmount
      //   : remainingAmount,
      return_amount: returnedCash,
      due_amount: duePayment,
      invoice_date: productionSelectedDate,
      payment_type: selectedEnumValue,
      customer_id: customerId,
      customer_name: customerName,
      customer_phone: customerPhone,
      customer_email: customerEmail,
      salesArray: salesData,
    };

    try {
      let res;

      if (editInvoiceId) {
        // Call EditSales if editInvoiceId is not "new"
        res = await dispatch(
          EditSales({
            pharmacy_id: salesPayload?.pharmacy_id,
            salesPayload: salesPayload,
          })
        );
      } else {
        // Call AddSales if editInvoiceId is "new"
        res = await dispatch(
          AddSales({
            pharmacy_id: salesPayload?.pharmacy_id,
            salesPayload: salesPayload,
          })
        );
      }
      setInvoiceId(res?.payload?.data?.invoice_id); // Set the invoiceId state

      if (res.payload.success === true) {
        setOpenSnackbar(true); // Open Snackbar
        getSalesHistory();
        // window.alert("Sales added successfully!");
      } else {
        window.alert("Failed to process sales. Please try again.");
      }
    } catch (error) {
      console.error("Error processing sales: ", error);
    }
  };
  // Handlers for input changes
  const handleDiscountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value == "") {
      return setDiscountPercentage("");
    }
    if (/^\d*\.?\d*$/.test(value)) {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 100) {
        setDiscountPercentage(value);
      }
    }
  };

  const handlePaidAmountChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (/^\d*\.?\d*$/.test(value) || value === "") {
      setPaidAmount(value);
    }
  };
  useEffect(() => {
    const numericValue = parseFloat(paidAmount || "");
    const isWalkInCustomer = customerPhone === "" || customerName === "";
    if (isWalkInCustomer && numericValue < totalPayable) {
      setPaidAmountError("Received amount cannot be less than due payment");
    } else {
      setPaidAmountError("");
    }
  }, [paidAmount, totalPayable, customerPhone, customerName]);

  const numericPaid = parseFloat(paidAmount || "0");
  const actualPayable = hasDiscountPercentagePrevious
    ? totalSingleMedDiscountPayable
    : totalPayable;

  const duePayment =
    customerPhone !== "" && customerName !== ""
      ? Math.max(actualPayable - numericPaid, 0)
      : 0;

  const returnedCash = Math.max(numericPaid - actualPayable, 0);

  const handleBackToNewSaleEntry = () => {
    setShowNewSaleEntry(true);
    setShowBackIcon(false); // Hide back icon when navigating back to NewSaleEntry
  };

  const handleGenerateInvoice = () => {
    // if (selectedPayment === "Cash") {
    //   setErrorMessage("Paid amount is required.");
    // }

    // // Clear error and proceed with generating invoice
    // setErrorMessage("");
    handleOpenModal();
  };

  const handleGenerateInvoiceAndSubmit = () => {
    const totalAmountToCompare = hasDiscountPercentagePrevious
      ? totalSingleMedDiscountPayable
      : totalPayable;

    // Condition when payment method is "Cash"
    // if (selectedPayment === "Cash") {
    // if (!paidAmount) {
    //   setErrorMessage("Paid amount is required.");
    //   return;
    // }

    const totalPaidAmoiunt =
      customerPhone !== "" && customerName !== "" ? paidAmount : duePayment;

    if (parseFloat(totalPaidAmoiunt) > totalAmountToCompare) {
      setErrorMessage("Paid amount cannot be less than total payable amount.");
      return;
    } else {
      setErrorMessage("");
      handleSubmit();
      handleGenerateInvoice();
    }
    // } else {

    //   setErrorMessage("");
    //   handleSubmit();
    //   handleGenerateInvoice();
    // }
  };

  const handleSaveAndClose = () => {
    setShowNewSaleEntry(true);
  };

  const paymentMethods = [
    { value: "visa", icon: "/icons/visa.png", label: "Visa" },
    { value: "jazzcash", icon: "/icons/jazzcash.png", label: "JazzCash" },
    // ...other methods
  ];

  // Calculate due payment
  // const duePayment = Math.max(
  //   (hasDiscountPercentagePrevious
  //     ? totalSingleMedDiscountPayable
  //     : totalPayable) - (parseFloat(paidAmount) || 0),
  //   0
  // );

  return (
    <>
      {showNewSaleEntry ? (
        <NewSaleEntry />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {showBackIcon && ( // Conditionally render the back icon
              <Box
                sx={{
                  width: "25%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 10,
                  position: "relative",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    cursor: "pointer",
                    position: "absolute",
                    top: 9,
                    left: 12,
                  }}
                  onClick={handleBackToNewSaleEntry}
                >
                  <BackIcon />
                </Box>
              </Box>
            )}{" "}
            {customerDetial && (
              <Box
                onClick={() => {
                  setCustomerDetail(() => !customerDetial);
                }}
                sx={{
                  type: "button",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "5px",
                  mt: "2vh",
                  mr: "1.5vh",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center", // centers the SVG vertically
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                      fill="#0055A8"
                    />
                    <path
                      d="M4.21045 6.73828H11.7894V9.2646H4.21045V6.73828Z"
                      fill="white"
                    />
                  </svg>
                </Box>

                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "#0055A8",
                  }}
                >
                  Hide Customer Details
                </Typography>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minHeight: "72vh",
            }}
          >
            {customerDetial && (
              <Box>
                <Box
                  sx={{
                    mt: 0.5,
                    border: "1px solid #D9D9D9",
                    p: 1.5,
                    borderRadius: 1,
                    mx: 1.2,
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 500,
                        lineHeight: "24px",
                        display: "flex",
                        alignItems: "center",
                        color: "#000000",
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      👤 Customer Details
                    </Typography>
                  </Box>
                </Box>
                <Grid container spacing={0} sx={{ ml: 1.5, gap: 3 }}>
                  <Grid item xs={12} md="auto">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          lineHeight: "24px",
                          color: "#333333",
                          fontFamily: theme.typography.fontFamily,
                          marginRight: "8px",
                        }}
                      >
                        Customer Number
                      </Typography>
                      <TextField
                        placeholder="03xx1234567"
                        variant="outlined"
                        size="small"
                        value={customerPhone}
                        onChange={(e) => handleCutPhone(e.target.value)}
                        sx={{
                          width: "260px",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "5px",
                            border: "1px solid #C4C4C4",
                            color: "#C4C4C4",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& input::placeholder": {
                            color: "#A1A1A1",
                            opacity: 1, // make sure color is visible
                          },
                          "& input": {
                            color: "#000000",
                          },
                        }}
                        inputProps={{
                          autoComplete: "off",
                          maxLength: 11,
                          inputMode: "numeric",
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md="auto">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          lineHeight: "24px",
                          color: "#333333",
                          fontFamily: theme.typography.fontFamily,
                          marginRight: "8px",
                          marginLeft: "12px", // small space between label and input
                        }}
                      >
                        Customer Name
                      </Typography>
                      <TextField
                        placeholder="Customer Name"
                        variant="outlined"
                        size="small"
                        value={customerName}
                        onChange={(e) => {
                          const onlyLetters = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            ""
                          );
                          handleCustName(onlyLetters);
                        }}
                        sx={{
                          width: "260px",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "5px",
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                            border: "1px solid #C4C4C4",
                            color: "#C4C4C4",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& input": {
                            color: "#000000",
                          },
                          "& input::placeholder": {
                            color: "#A1A1A1",
                            opacity: 1,
                          },
                        }}
                        inputProps={{
                          autoComplete: "off",
                          inputMode: "text",
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            <Box sx={{ padding: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "#000000",
                    mb: "2vh",
                    mt: "3vh",
                  }}
                >
                  Payments & Receivables
                </Typography>
                {!customerDetial && (
                  <Box
                    onClick={() => {
                      setCustomerDetail(() => !customerDetial);
                    }}
                    sx={{
                      type: "button",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: "5px",
                      mt: "2vh",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center", // centers the SVG vertically
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: "block" }} // removes extra bottom spacing
                      >
                        <path
                          d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z"
                          fill="#0055A8"
                        />
                        <path d="M6 3H9V12H6V3Z" fill="white" />
                        <path d="M3 6H12V9H3V6Z" fill="white" />
                      </svg>
                    </Box>

                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        lineHeight: "24px",
                        color: "#0055A8",
                      }}
                    >
                      Add Customer Details
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  border: "1px solid #D9D9D9",
                }}
              >
                <Box
                  sx={{
                    // border: "1px solid #D9D9D9",
                    borderRadius: "1px",
                    backgroundColor: "#FAFAFA",
                    padding: "20px",
                    display: "flex",
                    gap: 4,
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                  }}
                >
                  {/* LEFT SIDE */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        lineHeight: "1",
                        mb: 2,
                      }}
                    >
                      Total Amount:&nbsp;
                      <Box
                        component="span"
                        sx={{
                          color: "#2C323D",
                          fontWeight: 600,
                          fontSize: "20px",
                        }}
                      >
                        RS. {totalAmount?.toLocaleString()}
                      </Box>
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Add Discount
                      </Typography>

                      <TextField
                        placeholder="RS."
                        size="small"
                        variant="outlined"
                        value={amountPaid}
                        onChange={(e) => handleDiscountInputChange(e, "amount")}
                        sx={{ width: "120px" }}
                      />

                      <TextField
                        placeholder="0"
                        size="small"
                        variant="outlined"
                        value={discountPercentage}
                        onChange={(e) =>
                          handleDiscountInputChange(e, "percentage")
                        }
                        sx={{ width: "100px" }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">%</InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <PaymentModal
                      selectedInstructions={selectedInstructions}
                      setSelectedEnumValue={setSelectedEnumValue}
                      paidAmount={paidAmount}
                      handlePaidAmountChange={handlePaidAmountChange}
                      errorMessage={errorMessage}
                      hasDiscountPercentagePrevious={
                        hasDiscountPercentagePrevious
                      }
                      previousDiscountRemainingAmount={
                        previousDiscountRemainingAmount
                      }
                      remainingAmount={remainingAmount}
                      handleGenerateInvoiceAndSubmit={
                        handleGenerateInvoiceAndSubmit
                      }
                      openModal={openModal}
                      handleClose={handleClose}
                      invoiceId={invoiceId}
                      handleCloseModal={handleCloseModal}
                      handleSaveAndClose={handleSaveAndClose}
                      setSelectedPayment={setSelectedPayment}
                      selectedPayment={selectedPayment}
                      totalSingleMedDiscountPayable={
                        totalSingleMedDiscountPayable
                      }
                      totalPayable={totalPayable}
                      handleCloseEditFunction={handleCloseEditFunction}
                    />
                  </Box>

                  {/* RIGHT SIDE */}
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: "250px",
                      textAlign: "right",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#2C323D",
                      }}
                    >
                      Due Payment
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "26px",
                        fontWeight: 600,
                        color: "#0055A9",
                        mb: 2,
                      }}
                    >
                      RS. {duePayment.toLocaleString("en-IN")}
                    </Typography>

                    {/* Payable Amount Row */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        alignItems: "center",
                        mb: 2,
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          color: "#2C323D",
                        }}
                      >
                        Payable Amount
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 600,
                          color: "#00BB8C",
                        }}
                      >
                        RS.{" "}
                        {hasDiscountPercentagePrevious
                          ? totalSingleMedDiscountPayable?.toLocaleString()
                          : totalPayable?.toLocaleString()}
                      </Typography>
                    </Box>

                    {/* Receive Now Row */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        alignItems: "flex-start", // changed from "center" to "flex-start"
                        width: "100%",
                        gap: 2,
                        mt: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          color: "#2C323D",
                          pt: "6px", // adjust top padding to align with input
                        }}
                      >
                        Receive Now:
                      </Typography>
                      {(customerPhone !== "" && customerName !== "") || true ? (
                        <TextField
                          placeholder="Payment"
                          type="number"
                          size="small"
                          variant="outlined"
                          value={paidAmount}
                          onChange={handlePaidAmountChange}
                          sx={{ maxWidth: "200px", flexGrow: 1 }}
                          error={!!paidAmountError}
                          helperText={paidAmountError}
                        />
                      ) : (
                        <TextField
                          placeholder="Payment"
                          size="small"
                          variant="outlined"
                          sx={{ maxWidth: "200px", flexGrow: 1 }}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ p: 2, fontSize: "20px", fontWeight: "600" }}>
                  Returned Cash: RS. {returnedCash.toLocaleString("en-IN")}
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 10,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AppButton
                  variant="contained"
                  color="primary"
                  title="Generate Invoice"
                  sx={{
                    backgroundColor: "#0055A8",
                    "&.Mui-disabled": {
                      backgroundColor: "#c4c4c4",
                      color: "#fff",
                    },
                  }}
                  disabled={
                    !!paidAmountError ||
                    ((customerPhone === "" || customerName === "") &&
                      parseFloat(paidAmount || "0") < totalPayable)
                  }
                  onClick={handleGenerateInvoiceAndSubmit}
                />
              </Box>
            </Box>
          </Box>
          <AppModal
            title="Notes/Instructions"
            open={isChecked && savedModel}
            handleClose={handleCloseInstructions}
            fullScreen={false}
            maxWidth="sm"
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box>
                {instructionPayload?.instruction?.map((item: any) => (
                  <Box
                    key={item.id}
                    sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}
                  >
                    <Radio
                      checked={checkedItems[item.id] || false}
                      onChange={() => handleCheckboxChange(item.id)}
                      sx={{
                        color: "#212529",
                        "&.Mui-checked": { color: "#C32248" },
                        mr: 1,
                      }}
                    />

                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "14px",
                          lineHeight: "21px",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 300,
                          fontSize: "14px",
                          lineHeight: "21px",
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
              <Box
                sx={{
                  mt: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                  pt: 2,
                }}
              >
                {" "}
                <AppButton title="Save" onClick={handleSaveModel} />
              </Box>
            </Box>
          </AppModal>
        </>
      )}
    </>
  );
};

export default NewSaleCheckout;
